<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.OPTIONS.SELECT"
    :handler="
      async () => {
        activeOption =
          $constants.SERVICES.SERVICES_OPTIONS[
            $stores.services?.state?.transactionInitiation?.service?.id
          ]?.[0];

        await $nextTick();
        await $nextTick();
        await $nextTick();

        $refs.modal.show();
      }
    "
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.CLOSE_OPERATION_INITIATION"
    :handler="() => $refs.modal.hide()"
  />
  <DialogComponent
    ref="modal"
    type="bottomsheet"
    @closed="
      ({ source }) =>
        source !== 'external' &&
        $bus.emit($constants.EVENTS.SERVICES.CLOSE_OPERATION_INITIATION)
    "
    noInnerPadding
    noOverlay
    hideCloseButton
    :mainClass="
      ({ isLastDialog }) =>
        isLastDialog ? 'duration-300' : 'opacity-0 duration-300'
    "
  >
    <div
      :style="{
        backgroundColor:
          $stores.services.state?.transactionInitiation?.service?.color
      }"
      class="relative rounded-t-2xl"
    >
      <div class="pb-8 px-6 pt-4 -mb-5 relative">
        <div class="grid grid-cols-d5 items-center gap-3">
          <div class="col-span-4">
            <div class="text-white font-bold text-2xl">
              {{ $stores.services.state?.transactionInitiation?.service?.name }}
            </div>
            <div class="text-gray-100 text-lg">
              {{
                $stores.services.state?.transactionInitiation?.service
                  ?.descriptionLarge
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex flex-col gap-8 text-gray-400 p-6 bg-white rounded-t-3xl relative z-2"
    >
      <div
        class="p-4 px-6 rounded-2xl ripple border duration-300"
        @click="activeOption = option"
        :class="{
          ' border-gray-100!': activeOption?.id !== option.id,
          'shadow-sm': activeOption?.id == option.id
        }"
        :style="{
          borderColor: `${$stores.services.state?.transactionInitiation?.service.color}30`,
          backgroundColor:
            activeOption?.id == option.id
              ? `${$stores.services.state?.transactionInitiation?.service.color}05`
              : 'transparent'
        }"
        v-for="(option, i) in $constants.SERVICES.SERVICES_OPTIONS[
          $stores.services?.state?.transactionInitiation?.service?.id
        ] || []"
        :key="i"
      >
        <div class="flex items-center gap-2">
          <div class="w-5 h-5">
            <svg
              version="1.0"
              xmlns="http://www.w3.org/2000/svg"
              class="w-full h-full"
              :fill="
                activeOption?.id == option.id
                  ? $stores.services.state?.transactionInitiation?.service.color
                  : 'gray'
              "
              viewBox="0 0 512.000000 512.000000"
              preserveAspectRatio="xMidYMid meet"
            >
              <g
                transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                stroke="none"
              >
                <path
                  d="M2330 5110 c-494 -48 -950 -230 -1350 -538 -195 -150 -448 -432 -594 -662 -63 -99 -186 -351 -230 -471 -49 -134 -102 -340 -128 -499 -31 -195 -31 -565 0 -760 45 -276 116 -498 237 -745 132 -269 269 -460 489 -681 221 -220 412 -357 681 -489 247 -121 469 -192 745 -237 195 -31 565 -31 760 0 276 45 498 116 745 237 269 132 460 269 681 489 220 221 357 412 489 681 88 179 132 296 180 476 63 240 78 371 78 649 0 278 -15 409 -78 649 -48 180 -92 297 -180 476 -132 269 -269 460 -489 681 -221 220 -412 357 -681 489 -246 121 -474 193 -740 235 -147 23 -475 34 -615 20z m1569 -1452 c50 -16 127 -91 148 -146 24 -64 22 -147 -6 -205 -32 -65 -1678 -1699 -1752 -1740 -72 -38 -156 -38 -228 1 -42 22 -800 701 -929 832 -51 51 -76 113 -75 185 2 151 113 253 263 243 36 -3 80 -12 97 -22 27 -13 532 -468 696 -625 l47 -46 748 747 c411 410 761 753 779 762 69 35 131 39 212 14z"
                />
              </g>
            </svg>
          </div>
          <div
            class="font-medium"
            :style="{
              color:
                activeOption?.id == option.id
                  ? $stores.services.state?.transactionInitiation?.service.color
                  : 'inherit'
            }"
          >
            {{ option.title }}
          </div>
          <div class="w-8 h-8 ml-auto min-w-8">
            <div
              class="w-full h-full"
              :class="{ 'bg-gray-300!': activeOption?.id !== option.id }"
              style="
                mask-image: url(/images/icons/check-badge.svg);
                mask-size: cover;
              "
              :style="{
                backgroundColor:
                  $stores.services.state?.transactionInitiation?.service.color
              }"
            ></div>
          </div>
        </div>
        <div class="py-2"></div>
        <div
          class="text-xl font-medium"
          :class="{ 'text-gray-500': activeOption?.id == option.id }"
        >
          {{ option.description }}
        </div>
        <div class="font-medium">
          {{ option.smallText }}
        </div>
        <div class="py-2"></div>
      </div>

      <button
        class="buttonComponent mt-4 w-full flex! items-center justify-center gap-2"
        @click="
          $bus.emit($constants.EVENTS.SERVICES.OPTIONS.SELECTED, activeOption)
        "
        :style="{
          background:
            $stores.services.state?.transactionInitiation?.service.color
        }"
      >
        <span> Continuer </span>
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M14 5l7 7m0 0l-7 7m7-7H3"
          ></path>
        </svg>
      </button>
    </div>
  </DialogComponent>
</template>

<script setup>
import { ref } from 'vue';
const activeOption = ref(null);
</script>
